<section class="about-hero dingo-section section-first">
  <div class="container">
    <div class="about-hero-grid">
      <div class="about-hero-copy">
        <div class="section-head reveal-on-scroll" data-reveal="section-head" data-reveal-trigger="immediate">
          <p class="about-kicker">Grupo DINGO</p>
          <h1 class="about-title">
            Growth, creatividad y tecnología para empresas que quieren
            <span class="highlight-green">crecer con sistema</span>
          </h1>
          <p class="about-desc">
            Conectamos estrategia, data, creatividad y ejecución para convertir objetivos comerciales en crecimiento
            medible.
          </p>
        </div>

        <div class="about-hero-actions reveal-on-scroll" data-reveal="button" data-reveal-trigger="immediate" style="--reveal-order: 1">
          <a class="dingo-cta-primary" routerLink="/contacto">
            Hablemos
            <i class="bi bi-arrow-up-right"></i>
          </a>
          <a class="dingo-cta-secondary" href="#impacto">
            Ver industrias
            <i class="bi bi-grid-1x2"></i>
          </a>
        </div>
      </div>

      <figure class="dingo-hero-image-stage reveal-on-scroll" data-reveal="media" data-reveal-trigger="immediate" style="--reveal-order: 2">
        <div class="dingo-hero-image-stack">
          <img class="img-fluid dingo-cutout-edge-fix" src="assets/images/about/about.png" alt="Equipo DINGO conectando estrategia, data y tecnología" />
        </div>
      </figure>
    </div>

    <div class="about-principles">
      <article class="about-glass-card reveal-on-scroll" data-reveal="card" style="--reveal-order: 4">
        <span>01</span>
        <h4 class="about-card-title">Nuestra misión</h4>
        <p>
          Impulsar el éxito de nuestros clientes con estrategia integral, creatividad y tecnología que generan valor
          real y medible.
        </p>
      </article>
      <article class="about-glass-card reveal-on-scroll" data-reveal="card" style="--reveal-order: 5">
        <span>02</span>
        <h4 class="about-card-title">Nuestros valores</h4>
        <ul class="about-values-list">
          @for (value of aboutValues; track value) {
          <li>
            <i class="bi bi-check-circle-fill"></i>
            <span>{{ value }}</span>
          </li>
          }
        </ul>
      </article>
    </div>
  </div>
</section>
